(() => {
  const initStickyCart = (stickyCart) => {
    if (stickyCart.dataset.initialized === 'true') return;

    const sectionId = stickyCart.dataset.sectionId;
    const productInfo = document.getElementById(`MainProduct-${sectionId}`);
    const productInfoContent = document.getElementById(`ProductInfo-${sectionId}`);
    const stickyButton = stickyCart.querySelector('[data-bb-sticky-submit]');
    const stickyPrice = stickyCart.querySelector('[data-bb-sticky-price]');

    if (!productInfo || !stickyButton || !stickyPrice) return;

    stickyCart.dataset.initialized = 'true';
    let mainButtonVisible = true;

    const getMainButton = () => document.getElementById(`ProductSubmitButton-${sectionId}`);

    const getCurrentPrice = () => {
      const priceRoot = document.getElementById(`price-${sectionId}`);
      if (!priceRoot) return '';

      return (
        priceRoot.querySelector('.price--on-sale .price-item--sale') ||
        priceRoot.querySelector('.price__regular .price-item--regular:not(.variant-item__old-price)') ||
        priceRoot.querySelector('.price-item')
      )?.textContent.trim() || '';
    };

    const syncStickyCart = () => {
      const mainButton = getMainButton();
      if (!mainButton) return;

      const mainLabel = mainButton.querySelector('span')?.textContent.trim();
      stickyButton.textContent = mainLabel || 'Add to cart';
      stickyButton.disabled = mainButton.disabled || mainButton.getAttribute('aria-disabled') === 'true';

      const currentPrice = getCurrentPrice();
      if (currentPrice) stickyPrice.textContent = currentPrice;
    };

    const updateVisibility = () => {
      const shouldShow = !mainButtonVisible && window.scrollY > 120;
      stickyCart.classList.toggle('is-visible', shouldShow);
      stickyCart.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    };

    const mainButton = getMainButton();
    if (mainButton && 'IntersectionObserver' in window) {
      const visibilityObserver = new IntersectionObserver(
        ([entry]) => {
          mainButtonVisible = entry.isIntersecting;
          updateVisibility();
        },
        { threshold: 0.2 }
      );
      visibilityObserver.observe(mainButton);
    }

    const productObserver = new MutationObserver(syncStickyCart);
    productObserver.observe(productInfoContent || productInfo, {
      attributes: true,
      childList: true,
      subtree: true,
      characterData: true,
      attributeFilter: ['disabled', 'aria-disabled'],
    });

    stickyButton.addEventListener('click', () => {
      const currentMainButton = getMainButton();
      if (currentMainButton && !currentMainButton.disabled) currentMainButton.click();
    });

    window.addEventListener('scroll', updateVisibility, { passive: true });
    syncStickyCart();
    updateVisibility();
  };

  const init = (root = document) => {
    root.querySelectorAll('[data-bb-mobile-cart]').forEach(initStickyCart);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
